<template>
  <div class="profile-photo footer-max-width">
    <QHeader class="bg-black">
      <QToolbar>
        <QToolbarTitle>
          {{ $t("ETAB.PAGES.CROPPER.@TITLE") }}
        </QToolbarTitle>
      </QToolbar>
    </QHeader>

    <QPageContainer>
      <QPage>
        <Cropper :photo="profile[IEtabProfile.photo]" @on-submit="submit" @on-close="goToProfile" />
      </QPage>
    </QPageContainer>
  </div>
</template>

<script>
  import { mapState } from "pinia";
  import { useProfileStore } from "@etab/stores/profile";
  import { NotificationsManager } from "@core/managers/notifications.manager";
  import { EtabProfileService } from "@core/services";
  import { IEtabProfile } from "@core/models";
  import { GETTER_PROFILE_GET } from "@etab/stores/types";
  import Cropper from "@etab/components/common/Cropper.component.vue";
  import { ETAB_ROUTES } from "@etab/config";

  export default {
    components: {
      Cropper,
    },
    computed: {
      ...mapState(useProfileStore, {
        profile: GETTER_PROFILE_GET,
      }),
    },
    created() {
      this.IEtabProfile = IEtabProfile;
    },
    methods: {
      async submit(croppedPhoto) {
        try {
          this.$_startGlobalLoading();
          await EtabProfileService.savePhoto({ photo: croppedPhoto });
          this.profile[IEtabProfile.photo] = croppedPhoto;
        } catch (error) {
          NotificationsManager.error({ message: "ERRORS.@UNSAVED_MODIFICATIONS" });
          throw error;
        } finally {
          this.$_stopGlobalLoading();
        }
        this.goToProfile();
      },
      goToProfile() {
        // replace in order to not appear in route history
        this.$router.replace({ name: ETAB_ROUTES.account.profile.root.name });
      },
    },
  };
</script>
<style lang="scss">
  .profile-photo {
    background: black;
  }
</style>
